module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "background-color": "#F6F8FE",
      "height": "50px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "type": "text",
      "icon": "arrow-left"
    },
    on: {
      "click": _vm.backBtn
    }
  }, [_vm._v("\n\t\t\t 返回\n\t\t ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "addEnterprises"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules1,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "FileNo",
      "label": "数据类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择数据类型"
    },
    model: {
      value: (_vm.dataTypeValue),
      callback: function($$v) {
        _vm.dataTypeValue = $$v
      },
      expression: "dataTypeValue"
    }
  }, _vm._l((_vm.dataOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "FileNo",
      "label": "患者编号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入患者编号 (最长16位字符)",
      "maxlength": 16
    },
    model: {
      value: (_vm.ruleForm.FileNo),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "FileNo", $$v)
      },
      expression: "ruleForm.FileNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "PatientName",
      "label": "患者姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入患者姓名 (最长16位字符)",
      "maxlength": 16
    },
    model: {
      value: (_vm.ruleForm.PatientName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "PatientName", $$v)
      },
      expression: "ruleForm.PatientName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "OrderTime",
      "label": "订单日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.ruleForm.OrderTime),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "OrderTime", $$v)
      },
      expression: "ruleForm.OrderTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "Hospital",
      "label": "所属医院"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入所属医院 (最长16位字符)",
      "maxlength": 16
    },
    model: {
      value: (_vm.ruleForm.Hospital),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "Hospital", $$v)
      },
      expression: "ruleForm.Hospital"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "TimeInterval",
      "label": "CT间隔"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.timeIntervalDisabled,
      "placeholder": "请输入CT间隔 (范围值在0.125-5,单位为mm)",
      "maxlength": 6
    },
    model: {
      value: (_vm.ruleForm.TimeInterval),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "TimeInterval", $$v)
      },
      expression: "ruleForm.TimeInterval"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "submit marleft"
  }, [_c('el-button', {
    staticClass: "upLoadBtn",
    staticStyle: {
      "width": "100px",
      "height": "40px",
      "font-size": "14px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addFile
    }
  }, [_vm._v("\n\t\t\t\t\t\t确认上传\n\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "500px",
      "height": "300px",
      "margin-left": "500px",
      "margin-top": "-450px"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "accept": ".zip",
      "action": "http://112.125.27.239:8004/ZhenYuan/UploadFile/",
      "before-upload": _vm.onBeforeUpload,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleSuccess,
      "before-remove": _vm.beforeRemove,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#1F6AAB"
    },
    attrs: {
      "disabled": _vm.disabled,
      "size": "middle"
    }
  }, [_vm._v("选择文件")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tipTitle))])], 1), _vm._v(" "), _c('el-upload', {
    staticClass: "ct1upload-demo",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "accept": ".zip",
      "action": "http://112.125.27.239:8004/ZhenYuan/UploadFile/",
      "before-upload": _vm.onBeforeUpload_CT1,
      "on-preview": _vm.handlePreview_CT1,
      "on-remove": _vm.handleRemove_CT1,
      "on-success": _vm.handleSuccess_CT1,
      "before-remove": _vm.beforeRemove_CT1,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed_CT1,
      "file-list": _vm.fileList_CT1
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#1F6AAB"
    },
    attrs: {
      "disabled": _vm.disabled_CT1,
      "size": "middle"
    }
  }, [_vm._v("CT文件1")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tipTitle_CT1))])], 1), _vm._v(" "), _c('el-upload', {
    staticClass: "ct2upload-demo",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "accept": ".zip",
      "action": "http://112.125.27.239:8004/ZhenYuan/UploadFile/",
      "before-upload": _vm.onBeforeUpload_CT2,
      "on-preview": _vm.handlePreview_CT2,
      "on-remove": _vm.handleRemove_CT2,
      "on-success": _vm.handleSuccess_CT2,
      "before-remove": _vm.beforeRemove_CT2,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed_CT2,
      "file-list": _vm.fileList_CT2
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#1F6AAB"
    },
    attrs: {
      "disabled": _vm.disabled_CT2,
      "size": "middle"
    }
  }, [_vm._v("CT文件2")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tipTitle_CT2))])], 1), _vm._v(" "), _c('el-upload', {
    staticClass: "ct3upload-demo",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "accept": ".zip",
      "action": "http://112.125.27.239:8004/ZhenYuan/UploadFile/",
      "before-upload": _vm.onBeforeUpload_CT3,
      "on-preview": _vm.handlePreview_DCM,
      "on-remove": _vm.handleRemove_CT3,
      "on-success": _vm.handleSuccess_CT3,
      "before-remove": _vm.beforeRemove_CT3,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed_CT3,
      "file-list": _vm.fileList_CT3
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#1F6AAB"
    },
    attrs: {
      "disabled": _vm.disabled_CT3,
      "size": "middle"
    }
  }, [_vm._v("CT文件3")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tipTitle_CT3))])], 1), _vm._v(" "), _c('el-upload', {
    staticClass: "ct4upload-demo",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "accept": ".zip",
      "action": "http://112.125.27.239:8004/ZhenYuan/UploadFile/",
      "before-upload": _vm.onBeforeUpload_CT3,
      "on-preview": _vm.handlePreview_DCM,
      "on-remove": _vm.handleRemove_DCM,
      "on-success": _vm.handleSuccess_DCM,
      "before-remove": _vm.beforeRemove_DCM,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed_DCM,
      "file-list": _vm.fileList_DCM
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#1F6AAB"
    },
    attrs: {
      "disabled": _vm.disabled_DCM,
      "size": "middle"
    }
  }, [_vm._v("Dicom文件")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tipTitle_DCM))])], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52236af1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/AddFile.vue
// module id = 1105
// module chunks = 1